import React from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsCopyPasteInput from 'ui-elements/form-elements/FsCopyPasteInput';

interface FsMagicLinkFormProps {
  url: string;
}

const FsMagicLinkForm: React.FC<FsMagicLinkFormProps> = ({ url }) => {
  return (
    <Box>
      <FsBodySmall>{defaultLocales.magicLinkInstruction}</FsBodySmall>
      <Box marginTop={1.5}>
        <FsCopyPasteInput
          fsVariant="outlined"
          name={defaultLocales.magicLink.toLowerCase()}
          label={defaultLocales.magicLink}
          variant="outlined"
          fullWidth
          value={url}
        />
      </Box>
    </Box>
  );
};

export default FsMagicLinkForm;
